import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from '../../api.service';

export interface LoginSuccess {
  token: string;
  cnicNo: string;
  message: string; // "Login Successful"
}

export interface LoginError { message: string; }

export interface MemberUser {
  // existing
  emailAddress: string;
  memberStatus?: string;
  expiryDate?: string;
  orgMemberId?: string;

  // add the fields used by the dashboard template
  representativeName?: string;
  companyName?: string;
  orgMembershipNo?: string;
  cnicNo?: string;
  ntnNo?: string;
  statusId?: number;        // 0..5
  statusRemarks?: string;

}

export interface OldMember {
  MemID: string;
  type_id: number;
  pvt: string;
  status_id: number;
}

export interface CompanyInfo {
  expirydate: string;
}

export interface WebAdminConfig {
  serialNo?: number;
  name: string;
  status: number;
}

@Injectable({ providedIn: 'root' })
export class MemberLoginService {
  private http = inject(HttpClient);
  private api = inject(ApiService);


  authenticate(email: string, password: string): Observable<LoginSuccess> {
    return this.http.post<LoginSuccess>(
      `${this.api.authURL}authenticate/${encodeURIComponent(email)}/${encodeURIComponent(password)}`,
      {}
    );
  }

  /** GET User/GetEmployeData/{Email} */
  fetchUserDataByEmail(email: string): Observable<MemberUser> {
    return this.http.get<MemberUser>(
      `${this.api.memberURL}by-email/${encodeURIComponent(email)}`
    );
  }

  /** GET User/GetOldMemberData/{MemberID} */
  fetchLegacyProfile(orgMemberId: string | number): Observable<OldMember> {
    return this.http.get<OldMember>(`${this.api.memberURL}old/${orgMemberId}`);
  }

  /** GET User/GetCompanyInfo */
  fetchCompanyInfo(): Observable<CompanyInfo> {
    return this.http.get<CompanyInfo>(`${this.api.memberURL}company`);
  }




  fetchCompaniesByCnic(cnic: string): Observable<MemberCompanyCardDto[]> {
    return this.http.get<MemberCompanyCardDto[]>(
      `${this.api.memberURL}companies-by-cnic`,
      { params: new HttpParams().set('cnic', cnic) }
    );
  }


  fetchCompanyProfileByMemberId(memberId: string): Observable<MemberCompanyProfileDto> {
    return this.http.get<MemberCompanyProfileDto>(
      `${this.api.memberURL}company-profile/${encodeURIComponent(memberId)}`
    );
  }




}

export interface MemberCompanyProfileDto {
  memberId: string;
  membershipNo: string;

  companyName: string;
  companyAddress: string;
  representativeName: string;

  membershipExpiry?: string;
  membershipStatus: string;

  cnicNo?: string;
  ntnNo?: string;
}


export interface MemberCompanyCardDto {
  memberId: string;
  membershipNo: string;
  companyName: string;
  companyAddress: string;
  representativeName: string;
  membershipExpiry?: string;
  currentMembershipStatus: string;
}